/*
 * @Author: your name
 * @Date: 2020-11-13 13:02:10
 * @LastEditTime: 2021-02-07 18:48:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shop-cloud-private-web/src/pub/config/baseHost.js
 */
let resultHost = {
  BASEHOST_ARCHIVE: "", //云端  BASEHOST_ARCHIVE  私人订制
  BASEHOST_CLOUDSHARE: "", // 门店
  BASEHOST_REPORT: "", // 门店
  BASEHOST_ARCHIVEGENUINE: "", //云端BASEHOST_ARCHIVE（8031）
  BASEHOST_ACTIVITY: "",
};
let serverUrl = window.location.hostname;
if (process.env.NODE_ENV == "production") {
  // 生产环境
  resultHost.BASEHOST_ARCHIVE = "https://a.haidilao.com";
  resultHost.BASEHOST_ARCHIVEGENUINE = "https://" + serverUrl + ":8031";
  resultHost.BASEHOST_REPORT = "http://" + serverUrl + ":8032";
  resultHost.BASEHOST_CLOUDSHARE = "http://" + serverUrl + ":8020";
  resultHost.BASEHOST_ACTIVITY = "https://" + serverUrl + ":8031"; // 门店
} else if (process.env.NODE_ENV == "develop") {
  // 测试环境
  resultHost.BASEHOST_ARCHIVE = "https://testpos.hdltest.com:8031"; // 云端
  resultHost.BASEHOST_ARCHIVEGENUINE = "https://" + serverUrl + ":8031";
  resultHost.BASEHOST_REPORT = "https://" + serverUrl + ":8032";
  resultHost.BASEHOST_CLOUDSHARE = "https://" + serverUrl + ":8020"; // 门店
  resultHost.BASEHOST_ACTIVITY = "https://" + serverUrl + ":8031";
} else if (process.env.NODE_ENV == "development") {
  // 本地开发环境
  // resultHost.BASEHOST_ARCHIVE = 'http://172.25.11.101:9000';// 云端
  resultHost.BASEHOST_ARCHIVE = "https://testpos.hdltest.com:8031"; // 云端
  resultHost.BASEHOST_ARCHIVEGENUINE = "https://testpos.hdltest.com:8031"; // 云端
  resultHost.BASEHOST_REPORT = "http://172.25.10.65:8032";
  resultHost.BASEHOST_CLOUDSHARE = "http://10.0.252.5:8020"; // 门店
  resultHost.BASEHOST_ACTIVITY = "https://testpos.hdltest.com:8031"; // 云端
}
module.exports = resultHost;



// WEBPACK FOOTER //
// ./src/pub/config/baseHost.js